import type { ClusterProvider, DatabaseType } from '@/graphql.types'

const ociDumpBackupDatabaseTypes: DatabaseType[] = [
  'postgresql',
  'mysql',
  'mariadb',
  'redis',
  'valkey',
]

type DumpBackupCheckDatabase =
  | {
      type: DatabaseType
      cluster?: { provider: ClusterProvider } | null
    }
  | null
  | undefined

export const isOciDumpBackupDatabase = (database: DumpBackupCheckDatabase) =>
  database?.cluster?.provider === 'oci' &&
  ociDumpBackupDatabaseTypes.includes(database.type)
